import Sentiment from "./sentiment";

export default Sentiment;